import { fetchProfileData, FxIdApplicationStoreCreatePaymentHandlerEmbeddingType, FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus, FxIdDomainStoreEnumsSupportedWebPublishingPlatform } from "@fxid/openapi-client";
import OpenApiClient from "@fxid/openapi-client";
import { EFxIdSdkAdapterBuyProductResponseErrorCode, FxIdSdkAdapterSocialSettingDefault } from "@fxid/sdk-core";
import { getAuthToken } from "@fxid/shared";
import i18next from "i18next";
import { ok, telegram, vk } from "vanilla-sharing";
import { deferred } from "../types/FxIdSdkUtils";
import { FxIdSdkBaseAdapter } from "./FxIdSdkBaseAdapter";
export class FxIdSdkAdapterForTelegram extends FxIdSdkBaseAdapter {
    constructor(exportedSdk, game, config, dependencies) {
        super(exportedSdk, game, config, dependencies);
        this.exportedSdk = exportedSdk;
        this.game = game;
        this.config = config;
        this.adapter = "telegram";
        this.defaultSocialSettings = {
            ...FxIdSdkAdapterSocialSettingDefault,
            ui: {
                ...FxIdSdkAdapterSocialSettingDefault.ui,
                disabled: false
            }
        };
    }
    async GetInitData() {
        return Promise.resolve(window.Telegram.WebApp.initData);
    }
    async Initialize() {
        await new Promise((resolve) => {
            const s = document.createElement("script");
            s.type = "text/javascript";
            s.src = "https://telegram.org/js/telegram-web-app.js";
            s.async = false;
            s.defer = false;
            s.addEventListener("load", () => {
                log.info("Telegram web api loaded");
                resolve();
            });
            const head = document.getElementsByTagName("head")[0];
            head.appendChild(s);
            log.info("Telegram web api added");
        });
        log.info("Telegram adapter initialized. Platform: %o, Version: %o. Init data: %o", window.Telegram.WebApp.platform, window.Telegram.WebApp.version, window.Telegram.WebApp.initData);
    }
    GetSocialInfo() {
        const tmUser = window.Telegram.WebApp.initDataUnsafe.user;
        if (tmUser == null) {
            throw new Error("Telegram user is missing!");
        }
        const socialInfo = {
            social: FxIdDomainStoreEnumsSupportedWebPublishingPlatform.Telegram,
            paymentsAvailable: true,
            userId: tmUser.id.toString(),
            capabilities: [],
            displayName: tmUser.username,
            firstName: tmUser.first_name,
            lastName: tmUser.last_name
        };
        if (tmUser.photo_url != null) {
            socialInfo.photo = {
                url: tmUser.photo_url
            };
        }
        return Promise.resolve(socialInfo);
    }
    async BuyProduct(request) {
        const paymentRequest = {
            Token: getAuthToken(),
            Game: this.game,
            Sku: request.sku,
            WebPublishingPlatform: FxIdDomainStoreEnumsSupportedWebPublishingPlatform.Telegram,
            EmbeddingType: FxIdApplicationStoreCreatePaymentHandlerEmbeddingType.Embed,
            ProductDescriptionHint: request.productDescriptionHint,
            ProductNameHint: request.productNameHint
        };
        if (request.developerPayload != null) {
            paymentRequest.DeveloperPayload = {
                MerchantDeveloperPayload: request.developerPayload
            };
        }
        const createPaymentResult = await OpenApiClient.Store.fxIdWebFeaturesStoreCreatePaymentEndpoint(paymentRequest);
        log.info("Received result from server: %o", createPaymentResult);
        const tm = createPaymentResult.Telegram;
        if (tm == null) {
            throw new Error("Failed to create payment in telegram adapter - telegram data is empty");
        }
        log.info("Calling telegram api");
        const { promise, resolve, reject } = deferred();
        this.buyProductResolve = async (data) => {
            await OpenApiClient.Store.fxIdWebFeaturesStoreOrdersSetOptimisticOrderStatusSetOptimisticOrderStatusEndpoint({
                PublicOrderId: createPaymentResult.TransactionId,
                Status: FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus.Completed
            }).catch((e) => log.error("[TELEGRAM] Failed to set optimistic status:", e));
            resolve({
                ...data,
                transactionId: createPaymentResult.TransactionId,
                stats: {
                    currency: createPaymentResult.OrderProduct.Currency ?? "",
                    currencyAmount: createPaymentResult.OrderProduct.Price ?? 0,
                    usdAmount: createPaymentResult.OrderProduct.UsdPrice ?? 0
                }
            });
        };
        this.buyProductReject = async (data) => {
            await OpenApiClient.Store.fxIdWebFeaturesStoreOrdersSetOptimisticOrderStatusSetOptimisticOrderStatusEndpoint({
                PublicOrderId: createPaymentResult.TransactionId,
                Status: FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus.Cancelled
            }).catch((e) => log.error("[TELEGRAM] Failed to set optimistic status:", e));
            reject(data);
        };
        // Похоже в типах для либы не верная сигнатура - по доке в первом и единственном параметре придет статус, а тут урл и потом статус
        window.Telegram.WebApp.openInvoice(tm.InvoiceUrl, (s) => {
            log.info("Received open invoice result: %o", s);
            const status = s;
            if (s === "paid" || s === "pending") {
                this.buyProductResolve?.call(this, { transactionId: createPaymentResult.TransactionId });
            }
            else {
                this.buyProductReject?.call(this, {
                    error: s,
                    errorCode: status === "cancelled"
                        ? EFxIdSdkAdapterBuyProductResponseErrorCode.UserCancelled
                        : EFxIdSdkAdapterBuyProductResponseErrorCode.Unknown
                });
            }
        });
        return promise;
    }
    async RegisterShareHandlers() {
        const sharingHandler = this._dependencies.getSharingHandler();
        const data = { url: window.location, title: i18next.t(`seo.${this.game}.title`) };
        if (sharingHandler) {
            sharingHandler.enableShareVk?.(() => vk(data));
            sharingHandler.enableShareOk?.(() => ok(data));
            sharingHandler.enableShareTelegram?.(() => telegram(data));
            sharingHandler.enableLinkCopy?.(() => { });
        }
        const profileData = await fetchProfileData(this.game);
        const userDisplayName = profileData.Name ?? profileData.Email ?? `#${profileData.AccountId}`;
        this._dependencies.setUserId(String(profileData.AccountId));
        this._dependencies.setUserDisplayName(userDisplayName);
    }
    StoreCurrency() {
        return Promise.resolve("XTR");
    }
    StatInitialize(request) {
        return Promise.resolve();
    }
    StatEvent(request) {
        return Promise.resolve();
    }
}
